import { Box, Grid, IconButton, MenuItem, MenuList, Popover, Theme, Tooltip } from "@mui/material";
import {
  Search,
  Add,
  SaveAlt,
  RemoveRedEye,
  Image,
  Edit,
  InsertLink,
  Delete,
  Print,
  Clear,
  Visibility,
  UploadFile,
  DoneAll,
  Info,
  CheckCircle,
  Done,
  HistoryRounded,
} from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import DescriptionIcon from '@mui/icons-material/Description';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { I18n } from "utilities/utilities";
import { I18NextNs } from "enum/enum";
import { Link } from "react-router-dom";
import { BtnProp, BtnTableProp, IBtnMenuAddOnTable } from "./Button";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useState } from "react";
import { BtnBaseButton } from "./ButtonAll";
//#region OnTable

const GridBtnAddOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Add />}
      label={txt}
      sx={{
        bgcolor: "#1976d2",
        color: "white",
        ":hover": {
          bgcolor: "#0946a2",
        },
      }}
      onClick={onClick}
      aria-label={txt}
    />
  )
}

export const BtnAddOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Add", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnAddOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnAddOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }
  </Tooltip>
);

const GridBtnPreviewOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<RemoveRedEye />}
      label={txt}
      onClick={onClick}
      aria-label={txt}
      sx={(theme: Theme) => ({
        color: "#fff",
        backgroundColor: theme.palette.info.main,
        borderColor: theme.palette.info.light,
        ":hover": { bgcolor: theme.palette.info.dark },
      })}

    />
  )
}

export const BtnPreviewOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Preview", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnPreviewOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnPreviewOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }
  </Tooltip>
);

const GridBtnLinkOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<InsertLink />}
      label={txt}
      sx={(theme: Theme) => ({
        color: "#fff",
        backgroundColor: "#9e3eda",
        borderColor: "#9e3eda",
        ":hover": { bgcolor: "#671d96" },
      })}
      onClick={onClick}
      aria-label={txt}
    />
  )
}

export const BtnLinkOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Link", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnLinkOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnLinkOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }

  </Tooltip>
);

const GridBtnViewImageOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <Tooltip title={txt}>
      <GridActionsCellItem
        id={id}
        disabled={IsDisabled}
        hidden={IsHidden}
        icon={<Image />}
        label={txt}
        sx={{
          backgroundColor: "tranparent",
          color: "#4f5bef",
          ":hover": { bgcolor: "#d7d7d7" },
        }}
        onClick={onClick}
        aria-label={txt}
      />
    </Tooltip>
  )
}

export const BtnViewImageOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.ViewImage", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnViewImageOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnViewImageOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }

  </Tooltip>
)

const GridBtnEditOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <Tooltip title={txt}>
      <GridActionsCellItem
        id={id}
        disabled={IsDisabled}
        hidden={IsHidden}
        icon={<Edit />}
        label={txt}
        onClick={onClick}
        aria-label={txt}
        sx={
          IsHidden !== true ? {
            backgroundColor: "#ffc107",
            color: "white",
            ":hover": { bgcolor: "#cc9900" },
            margin: "1%",
          }
            :
            {
              display: "none",
              backgroundColor: "#ffc107",
              color: "white",
              ":hover": { bgcolor: "#cc9900" },
              margin: "1%",
            }
        }
      />
    </Tooltip>
  )
}

export const BtnEditOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnEditOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnEditOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }
  </Tooltip>
)

export const BtnViewOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.View", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Visibility />}
      label={txt}
      sx={{
        backgroundColor: "#6FDBFF",
        color: "white",
        ":hover": { bgcolor: "#5DB6D4" },
        margin: "1%",
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
)

export const BtnDeleteOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Delete", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Delete />}
      label={txt}
      sx={{
        backgroundColor: "#f30800",
        color: "white",
        ":hover": { bgcolor: "#d8352f" },
        margin: "1%",
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
)

export const BtnSearchOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Search", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Search />}
      label={txt}
      sx={{
        backgroundColor: "#096ddd",
        color: "white", //black
        ":hover": { bgcolor: "#004290" },
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
)

export const BtnPrintOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Print", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Print />}
      label={txt}
      sx={{
        backgroundColor: "#096ddd",
        color: "orange", //black
        ":hover": { bgcolor: "#004290", cursor: "pointer" },
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>

)

export const BtnVersionOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = "เวอร์ชัน",
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<HistoryRounded />}
      label={txt}
      sx={{
        backgroundColor: "#fb7100",
        color: "white",
        ":hover": { bgcolor: "#de741d", cursor: "pointer" },
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
)

const GridBtnReserveOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Edit />}
      label={txt}
      sx={{
        backgroundColor: "#1000f3",
        color: "white", //black
        ":hover": { bgcolor: "#2d22b9" },
      }}
      onClick={onClick}
      aria-label={txt}
    />
  )
}

export const BtnReserveOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Reserve", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnReserveOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnReserveOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }

  </Tooltip>
)

export const BtnDownloadOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Download", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<SaveAlt />}
      label={txt}
      sx={{
        backgroundColor: "#4db9cf",
        color: "white", //black
        ":hover": { bgcolor: "#4db9cf" },
        margin: "1%",
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
)

export const BtnClearOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Clear", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Clear />}
      label={txt}
      sx={{
        backgroundColor: "#f32400",
        color: "white",
        ":hover": { bgcolor: "#f32400" },
        margin: "1%",
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
)


export const BtnSubOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.SubDetail", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<DehazeIcon />}
      label={txt}
      sx={{
        color: "#1976d2",
        ":hover": {
          bgcolor: "#0946a2",
        },
      }}
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
);

const GridBtnViewOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Edit", I18NextNs.labelComponent),
  onClick = () => { },
  id
}: BtnTableProp) => {
  return (
    <Tooltip title={txt}>
      <GridActionsCellItem
        id={id}
        disabled={IsDisabled}
        hidden={IsHidden}
        icon={<DescriptionIcon />}
        label={txt}
        sx={
          IsHidden !== true ? {
            backgroundColor: "#1976d2",
            color: "white",
            ":hover": { bgcolor: "#0946a2" },
            margin: "1%",
          }
            :
            {
              display: "none",
              backgroundColor: "#1976d2",
              color: "white",
              ":hover": { bgcolor: "#0946a2" },
              margin: "1%",
            }
        }
        onClick={onClick}
        aria-label={txt}
      />
    </Tooltip>
  )
}

export const BtnViewDataOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.View", I18NextNs.labelComponent),
  onClick = () => { },
  href,
  id
}: BtnTableProp) => (
  <Tooltip title={txt}>
    {
      href ?
        <Link
          to={href}
          preventScrollReset={true}
          style={{ textDecoration: 'none', pointerEvents: IsDisabled ? 'none' : 'all' }}
        >
          <GridBtnViewOnTable
            id={id}
            IsHidden={IsHidden}
            IsDisabled={IsDisabled}
            txt={txt}
          />
        </Link>
        :
        <GridBtnViewOnTable
          onClick={onClick}
          id={id}
          IsHidden={IsHidden}
          IsDisabled={IsDisabled}
          txt={txt}
        />
    }
  </Tooltip>
);

export const BtnUpdateDataOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.UpdateData", I18NextNs.labelComponent),
  onClick = () => { },
  id,
  icon = <UploadFile />,  
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={icon}
      label={txt}
      sx={
        IsHidden !== true ? {
          backgroundColor: "#A569BD",
          color: "white",
          ":hover": { bgcolor: "#7D3C98" },
          margin: "1%",
        }
          :
          {
            display: "none",
            backgroundColor: "#A569BD",
            color: "white",
            ":hover": { bgcolor: "#7D3C98" },
            margin: "1%",
          }
      }
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
);

export const BtnApproveOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = I18n.SetText("Button.Approve", I18NextNs.labelComponent),
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<DoneAll />}
      label={txt}
      //เขียว
      sx={
        IsHidden !== true ? {
          backgroundColor: "#58D68D",
          color: "white",
          ":hover": { bgcolor: "#2ECC71" },
          margin: "1%",
        }
          :
          {
            display: "none",
            backgroundColor: "#58D68D",
            color: "white",
            ":hover": { bgcolor: "#2ECC71" },
            margin: "1%",
          }
      }
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
);

export const BtnMenuAddOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = null,
  onClick = () => { },
  handleAddItem = () => { },
  id,
  arrTableMenu = [],
  setAnchorEL,
  anchorEL,
  nItemRowId,
  nOrderNumber,
  
}: IBtnMenuAddOnTable) => (
  <>
    <Tooltip title={txt}>
      <IconButton
        hidden={IsHidden}
        onClick={onClick}
        aria-label={txt}
        sx={
          IsHidden !== true ? {
            margin: "1%",
          }
            :
            {
              display: "none",
              margin: "1%",
            }
        }
      >
        <MoreHorizIcon />
      </IconButton>
    </Tooltip>

    {/* add menu row*/}
    <Box
      className="logout-menu"
      style={{ justifyContent: "center", alignItems: "center" }}
    >
      <Popover
        id="mouse"
        open={Boolean(anchorEL)}
        anchorEl={anchorEL}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        // transformOrigin={{
        //   vertical: 'top',
        //   horizontal: 'left',
        // }}
        style={{ cursor: "pointer", minWidth: "250px", borderRadius: "20px" }}
        onClose={() => { setAnchorEL(null) }}
      >
        <Grid container direction={'row'}>
          <Grid item xs={12}>
            {arrTableMenu.map((m) => (
              <MenuList
                // autoFocusItem={open}
                id={id}
                aria-labelledby="composition-button"
              // onKeyDown={handleListKeyDown}
              >
                <MenuItem
                  key={m.value + "_" + nItemRowId}
                  id={m.value + "_" + nItemRowId}
                  onClick={(e) => { handleAddItem(m.value, nItemRowId, nOrderNumber); setAnchorEL(null); }}
                  disabled={IsDisabled}
                >
                  {m.Label}
                </MenuItem>
              </MenuList>
            ))}
          </Grid>
        </Grid>
      </Popover>
    </Box>
  </>
);

export const BtnUploadOnTable = ({
  id,
  IsDisabled = false,
  IsHisabled = false,
  txt = "อัปโหลด",
  onClick = () => { },
}) => (
  <GridActionsCellItem
    id={id}
    disabled={IsDisabled}
    hidden={IsHisabled}
    icon={<Tooltip title={txt}><UploadFile /></Tooltip>}
    label={txt}
    sx={{
      backgroundColor: "#4db9cf",
      color: "white", //black
      ":hover": { bgcolor: "#4db9cf" },
      margin: "1%",
    }}
    onClick={onClick}
    aria-label={txt}
  />
)

export const BtnExamineOnTable = ({
  IsDisabled = false,
  IsHidden = false,
  txt = "",
  onClick = () => { },
  id
}) => (
  <Tooltip title={txt}>
    <GridActionsCellItem
      id={id}
      disabled={IsDisabled}
      hidden={IsHidden}
      icon={<Done />}
      label={txt}
      //เขียว
      sx={
        IsHidden !== true ? {
          cursor: "default",
          backgroundColor: "#58D68D",
          color: "white",
          ":hover": { bgcolor: "#2ECC71" },
          margin: "1%",
        }
          :
          {
            display: "none",
            backgroundColor: "#58D68D",
            color: "white",
            ":hover": { bgcolor: "#2ECC71" },
            margin: "1%",
          }
      }
      onClick={onClick}
      aria-label={txt}
    />
  </Tooltip>
);

export const BtnPassReview = (props: BtnProp) => {
  const {
    IsDisabled = false,
    IsHidden = false,
    onClick = () => { },
    txt = I18n.SetText("Button.Draft", I18NextNs.labelComponent),
    IsCircleWithOutText = false,
    IsRadius = true,
  } = props;

  return (
    <BtnBaseButton
      txt={txt}
      size={"medium"}
      startIcon={<CheckCircle />}
      IsRadius={IsRadius}
      IsDisabled={IsDisabled}
      IsHidden={IsHidden}
      onClick={onClick}
      IsCircleWithOutText={IsCircleWithOutText}
      bgcolor="#4ca733"
      bgcolorHover="#3b8726"
      fontColor="#ffffff"
      tooltipPlacement="bottom"
      className={props.className}
      id={props.id}
    />
  );
};

//#endregion
